<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
          <v-toolbar dense dark color="blue darken-2">
              <v-toolbar-title>
                  <h3>{{get_dialogMain.title}}</h3>
              </v-toolbar-title>
            <v-spacer/>
              <v-btn icon dark @click="HIDDE_DIALOG_MAIN">
                  <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-toolbar>
          <v-card-text class="my-1">
            <v-row dense v-if="showInsumo">
              <v-col cols="12">
                <FormsMainGral titleButton="Agregar"
                  :formCreate="formInsumo"
                  :on-success="addInsumo"
                  :model="insumo"/>
              </v-col>
              <v-col cols="12">
              <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
              </v-col>
              <v-col cols="12">
                <v-layout justify-end>
                    <v-btn color="success darken-1" depressed outlined @click="addInsumos" class="mr-3"> finalizar Insumos </v-btn>
                </v-layout>
              </v-col>
            </v-row>

            <v-row dense v-if="!showInsumo">
              <v-col cols="12" v-if="form.status_finish.formulario.actions">
                <span v-for="(item, index) in form.status_finish.formulario.actions" :key="index" class="pt-4">
                  <v-btn small :color="item.color" dark class="mr-1" @click="successAction(item)" :disabled="item.disabled">
                      {{ item.title }}
                      <v-icon right dark v-if="item.icon">{{ item.icon }}</v-icon>
                  </v-btn>
                </span>
              </v-col>
              <v-col cols="12">
                <FormsMain :formCreate="form" :on-success="saveEquipo" :on-cancel="closeDialog" :model="descripcion" />
              </v-col>
            </v-row>
          </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import FormsMain from '@/components/forms/formsMain'
import FormsMainGral from '@/components/forms/formsMainGral'
import DataTableMain from '@/components/tables/DataTableMainLocal'

export default {
  name: 'dialogMain',
  props: ['model'],
  data: () => ({
    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    descripcion: {},
    formInsumo: {
      fields: []
    },
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Insumo', value: 'insumo.NombreEquipo', class: 'black--text' },
          { text: 'Cantidad', value: 'cantidad', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: { paging: true }
    },
    showInsumo: false,
    insumo: {}
  }),
  components: {
    FormsMain,
    FormsMainGral,
    DataTableMain
  },
  mounted () {
    this.user = this.$cookies.get('user')
    if (this.get_dialogMain.type === 'exitInsumo') {
      this.showInsumo = true
    }
    if (this.model.action) {
      this.form = this.model.body
      if (this.form.status_finish.formulario.fieldsDetail) {
        this.formInsumo.fields = Object.assign([], this.form.status_finish.formulario.fieldsDetail)
      }
    } else {
      this.getFormDataUrl('ma.options')
    }
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.showInsumo = true
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    ...mapActions(['getFormServicesAction', 'postExecuteAction']),
    getFormDataUrl (url) {
      const router = this.get_urls[url]
      this.getFormServicesAction({ url: router, params: '/7' })
    },
    saveEquipo (model) {
      model.empleado = this.user.empleado_id
      model.departamento = this.user.departamento_id
      if (this.get_dialogMain.type !== 'create') {
        model.id = this.model.item.id
      }
      if (this.form.status_finish.formulario.fieldsDetail) {
        model.descripcion.insumos = this.table.body.data
      }
      const router = this.get_urls['ma.execute']
      this.postExecuteAction({ url: router, data: model })
    },
    addInsumo (model) {
      console.log(model)
      let isExist = false
      this.table.body.data.map(item => {
        if (item.insumo_id === model.insumo_id) {
          isExist = true
        }
      })
      if (!isExist) {
        if (this.get_objectFind) {
          const descripcion = JSON.parse(this.get_objectFind.descripcion)
          model.nombre = descripcion.nombre
        }
        this.table.body.data.push(model)
      } else {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El insumo ya esta agregado a la lista !!'
        })
      }
      this.insumo = {}
    },
    addInsumos (model) {
      this.showInsumo = false
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'RELOAD_DATA_OBJECT', 'CLEAR_OBJECTS_OPTIONS', 'CLEAR_OBJECTS_MODEL', 'SET_LOADING_STATUS']),
    closeDialog () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_options', 'get_model', 'get_objectFind'])
  },
  watch: {
    get_options (vals) {
      if (vals) {
        this.form = vals
      }
    },
    get_model (val) {
      this.SET_LOADING_STATUS(false)
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente !!'
      })
      this.RELOAD_DATA_OBJECT(val)
      this.closeDialog()
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS_OPTIONS()
    this.CLEAR_OBJECTS_MODEL()
  }
}
</script>
<style></style>
